module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('el-form', [_c('el-row', [_c('h4', [_vm._v("园所信息")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所名称："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.SchoolInfo.SchoolName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园长："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.SchoolInfo.PrincipalName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园长电话："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.SchoolInfo.PhoneNo))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所地址："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.SchoolInfo.SchoolAddress))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("园所网络情况")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所网络运营商："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.NetInfo.NetworkOperatorName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所班级是否有网络："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.NetInfo.IsSpecilLine))])])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.NetInfo.DistanceName !== ''),
      expression: "NetInfo.DistanceName!==''"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "网络到一体机电视距离："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.NetInfo.DistanceName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否需要IT工程师上门服务："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.NetInfo.EngineerName))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("下单人信息")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "业务员："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.SalesInfo.C_Name))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "业务员电话："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.SalesInfo.C_Tel))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeTab
    },
    model: {
      value: (_vm.TabId),
      callback: function($$v) {
        _vm.TabId = $$v
      },
      expression: "TabId"
    }
  }, _vm._l((_vm.TabsTypes), function(item) {
    return _c('el-radio-button', {
      attrs: {
        "size": "small",
        "label": item.index
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("班级信息")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "班级年段："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.SchoolInfo.SchoolName) + "-" + _vm._s(_vm.ClassInfo.GradeName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "班级昵称："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ClassInfo.ClassNick))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备绑定码："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ClassInfo.ClassId))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "班主任姓名："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ClassInfo.TeacherInfo.UserName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "班主任电话："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ClassInfo.TeacherInfo.PhoneNo))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("网络检测跟进情况")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.FollowInfo,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "跟进人",
      "prop": "FollowEmployeeName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "跟进时间",
      "prop": "FolllowTime"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "检测进度",
      "prop": "FollowScheduleName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "检测结果",
      "prop": "FollowStatusName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "prop": "Remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "footer"
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-508244e9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/orderViewList/OrderQ2Page/networkDialog/index.vue
// module id = 1476
// module chunks = 1